import apiClient from 'services/_infra/apiClient';
import { loginfo } from 'services/_infra/util/apiUsageLogger';
import { notifyCommandResultToast, resolveMessageText } from 'utils/notifications/toast.utils';

export async function sendDeviceCommand(device, newStatus, comment, maintenanceOverride, args) {
  try {
    loginfo();
    const response = await apiClient.post(`/v2/integrations/device/${device.id}/command`, {
      device: {
        node_id: device.node_id,
        status: Number(newStatus),
        comment: comment,
        maintenanceOverride: maintenanceOverride,
        system_type: device.system_type,
        device_type: device.device_type,
        ...args,
      },
    });

    const successMessage =
      resolveMessageText(response?.data) || 'Device command completed successfully.';
    notifyCommandResultToast({
      kind: 'success',
      scope: 'device',
      targetId: device?.id,
      status: Number(newStatus),
      message: successMessage,
    });

    return response;
  } catch (error) {
    const errorMessage =
      resolveMessageText(error?.response?.data) ||
      resolveMessageText(error?.message) ||
      'Failed to send device command.';

    notifyCommandResultToast({
      kind: 'error',
      scope: 'device',
      targetId: device?.id,
      status: Number(newStatus),
      message: errorMessage,
    });

    throw error;
  }
}

export async function sendGroupCommand(group, newStatus, comments, args) {
  try {
    loginfo();
    const response = await apiClient.post(`/v2/integrations/device-group/${group}/command`, {
      groupId: group,
      status: Number(newStatus),
      comments: comments,
      ...args,
    });

    const successMessage =
      resolveMessageText(response?.data) || 'Group command completed successfully.';
    notifyCommandResultToast({
      kind: 'success',
      scope: 'group',
      targetId: group,
      status: Number(newStatus),
      message: successMessage,
    });

    return response;
  } catch (error) {
    const errorMessage =
      resolveMessageText(error?.response?.data) ||
      resolveMessageText(error?.message) ||
      'Failed to send group command.';

    notifyCommandResultToast({
      kind: 'error',
      scope: 'group',
      targetId: group,
      status: Number(newStatus),
      message: errorMessage,
    });

    throw error;
  }
}
